<template lang="pug">
  .view-animation(:class="{ active: isShowAnimation }")
    .view-animation-item(v-for="key in animationList" :class="`type-${key}`")
      .view-animation-player(
        ref="animationItem"
        :data-key="`${key}`"
      )
</template>

<script>
import _ from 'lodash';

import PreloadAnimation from '@/assets/js/data/preloadAnimation';

import Utils from '@/assets/js/Utils';

export default {
  name: 'Animation',
  data() {
    return {
      animation: null,
      animationDataList: [],
      timerCounter: null,
      isShowAnimation: false
    };
  },
  computed: {
    animationList() {
      return PreloadAnimation.list;
    }
  },
  beforeDestroy() {
    if (this.timerCounter) clearInterval(this.timerCounter);
    if (this.animation) this.animation.bodymovin.goToAndStop(0);
  },
  methods: {
    load(onComplete) {
      PreloadAnimation.loadItemAll(this.$refs.animationItem).then(dataList => {
        this.animationDataList = dataList;
        onComplete();
      });
    },
    play(key, onComplete, onProcess) {
      this.isShowAnimation = true;
      this.animation = _.find(this.animationDataList, { key: key });

      const complete = () => {
        if (key === 'goal') {
          this.animation.element.parentNode.classList.add('is-show-filter');
          Utils.wait(1100).then(() => {
            this.animation.element.parentNode.classList.remove('active');
            this.isShowAnimation = false;
            onComplete(this.animation);
          });
        } else {
          this.animation.element.parentNode.classList.remove('active');
          this.isShowAnimation = false;
          onComplete(this.animation);
        }
        this.animation.bodymovin.goToAndStop(0);
        if (this.timerCounter) clearInterval(this.timerCounter);
      };

      if (!this.animation.isSetComplete) {
        this.animation.bodymovin.addEventListener('complete', complete);
      }
      this.animation.isSetComplete = true;

      if (onProcess) {
        this.timerCounter = setInterval(() => {
          onProcess(this.animation.bodymovin);
        }, 100);
      }

      this.animation.element.parentNode.classList.add('active');
      this.animation.bodymovin.play();
    }
  }
};
</script>

<style scoped lang="scss">
.view-animation {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  &.active {
    width: 100%;
    height: 100%;
  }
  &-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    &.active {
      opacity: 1;
    }
    &.type-countDown {
      width: 100%;
      height: 100%;
      .view-animation-player {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &.type-goal {
      background-color: map-get($primary_color, 'grass');
      &::before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #fff433;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
        z-index: 1;
      }
      &.is-show-filter {
        &::before {
          animation: background 1.2s ease-in-out;
        }
      }
    }
  }
  &-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}

@keyframes background {
  0% {
    opacity: 0;
    background-color: #fff433;
  }
  50% {
    opacity: 1;
    background-color: #fff433;
  }
  100% {
    opacity: 1;
    background-color: #000;
  }
}
</style>
